import {useContext, useEffect} from 'react'
import Search from '../../../../components/Search'
import {CostAnalysisReportContext} from '../../context'
import usePermission from '../../../../hook/usePermission'
import useGetJobData from '../../../jobs/hooks/useGetJobData'
import {formatDate} from '../../../../utils/date'
import {useLocation, useNavigate} from 'react-router-dom'

const CostAnalysisReportHeader = () => {
  const {hasPermission} = usePermission()
  const location = useLocation()
  const navigate = useNavigate()
  const id = new URLSearchParams(location.search).get('id')

  const {onSearch} = useContext(CostAnalysisReportContext)
  const {jobData, runTask, refetchJobData} = useGetJobData(
    'sync_price_lists_from_bigcommerce_to_admin_app'
  )

  useEffect(() => {
    let intervalId: any = null
    if (jobData?.status === 'running') {
      intervalId = setInterval(() => {
        refetchJobData()
      }, 30000)
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobData?.status === 'running', refetchJobData])

  const onReset = () => {
    navigate(`/products/price-cost?view=cost-analysis-report&id=`)
  }

  return (
    <header className='d-flex align-items-center justify-content-between mb-10'>
      <Search onSearch={onSearch} />
      <div className='d-flex align-items-center gap-5'>
        {hasPermission('settings_jobs', 'write') && (
          <div className='position-relative d-flex align-items-center'>
            <span className='me-2'>Last Sync:</span>
            <span className='me-3'>{formatDate(jobData.last_run_end_time, false)} </span>
            {jobData?.status !== 'running' ? (
              <>
                {
                  <i
                    className='fas fa-sync cursor-pointer fs-5'
                    onClick={() => runTask('sync_price_lists_from_bigcommerce_to_admin_app')}
                  ></i>
                }
              </>
            ) : (
              <div className='d-flex justify-content-center'>
                <div className='spinner-border text-success' role='status'>
                  <span className='sr-only'>Loading...</span>
                </div>
              </div>
            )}
          </div>
        )}
        {id && (
          <button className='btn btn-outline' onClick={() => onReset()}>
            Reset
          </button>
        )}
      </div>
    </header>
  )
}

export default CostAnalysisReportHeader
